import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";

const IG_URL = "https://www.instagram.com/whitneyjeanco/";

const BRAND_IMG =
  "https://customer-assets.emergentagent.com/job_creative-market-76/artifacts/fqh2tshy_email1783908397780image9.png";
const WELCOME_IMG =
  "https://customer-assets.emergentagent.com/job_creative-market-76/artifacts/20cxwxra_email1783908334767image6.png";

const HIGHLIGHTS = [
  { label: "Branding", note: "Logos + identity systems" },
  { label: "Social", note: "Instagram content + reels" },
  { label: "Print", note: "Menus, flyers, posters" },
  { label: "Campaigns", note: "Launches + seasonal" },
];

export default function InstagramWork() {
  return (
    <section
      id="work"
      data-testid="instagram-work-section"
      className="py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto w-full px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-12 items-start">
          {/* Copy */}
          <div className="col-span-12 md:col-span-6">
            <div className="flex items-center gap-3">
              <span className="w-8 h-px bg-[#1C1B1A]"></span>
              <span className="font-mono-label text-[#635F59]">
                Our Work
              </span>
            </div>
            <h2 className="mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              See our work
              <br />
              <span className="italic text-[#B4A087]">on Instagram.</span>
            </h2>
            <p className="mt-6 text-base md:text-lg text-[#635F59] leading-relaxed max-w-lg">
              Our portfolio lives where the work lives — on Instagram. Browse
              our highlights for branding, social media, campaigns and design
              projects, plus a fresh feed of what we&apos;re building right now.
            </p>

            <div className="mt-8 grid grid-cols-2 gap-3 max-w-lg">
              {HIGHLIGHTS.map((h) => (
                <div
                  key={h.label}
                  data-testid={`ig-highlight-${h.label.toLowerCase()}`}
                  className="border border-[#E5E0D8] p-4"
                >
                  <p className="font-mono-label text-[#B4A087]">{h.label}</p>
                  <p className="mt-2 text-sm text-[#635F59]">{h.note}</p>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <a
                href={IG_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="work-instagram-cta"
                className="inline-flex items-center justify-center gap-3 bg-[#1C1B1A] text-[#FBF9F6] px-7 py-4 text-sm hover:bg-[#33312E] transition-colors"
              >
                <Instagram size={18} strokeWidth={1.5} />
                Visit @whitneyjeanco
                <ArrowUpRight size={16} strokeWidth={1.5} />
              </a>
              <a
                href="#contact"
                data-testid="work-inquiry-cta"
                className="inline-flex items-center justify-center gap-2 border border-[#1C1B1A] px-7 py-4 text-sm hover:bg-[#1C1B1A] hover:text-[#FBF9F6] transition-colors"
              >
                Book a free consultation
              </a>
            </div>
          </div>

          {/* Visual */}
          <motion.a
            href={IG_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="work-instagram-image-cta"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-6 group grid grid-cols-2 gap-3 md:gap-4"
          >
            <div className="wj-image-hover relative aspect-[9/16] overflow-hidden border border-[#E5E0D8] bg-[#F2EEE9]">
              <img
                src={BRAND_IMG}
                alt="Whitney Jean & Co. branding mockups"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
            <div className="wj-image-hover relative aspect-[9/16] overflow-hidden border border-[#E5E0D8] bg-[#F2EEE9] mt-8 md:mt-12">
              <img
                src={WELCOME_IMG}
                alt="Whitney Jean & Co. content mockups"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-[#1C1B1A]/0 group-hover:bg-[#1C1B1A]/15 transition-colors duration-500"></div>
              <div className="absolute bottom-4 right-4 bg-[#1C1B1A] text-[#FBF9F6] px-3 py-2 font-mono-label flex items-center gap-2">
                @whitneyjeanco <ArrowUpRight size={12} strokeWidth={1.75} />
              </div>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  );
}
